<template>
  <div class="mian_width" style="margin: 0;" id="main_popup">
    <ul
      style="
        width: 100%;
        display: table;
        margin: 0;
        border-bottom: 1px solid #166df1;
      "
    >
      <li
        style="width: 33%; text-align: left; margin-left: 2%; margin-bottom: 0;"
      >
        <img
          id="main_log_ico"
          style="height: 40px; vertical-align: middle;"
          src="../assets/image/logo.png"
        />
      </li>
      <li style="width: 27%; text-align: center; margin: 0;">
        <h3
          style="
            margin: 0;
            line-height: 40px;
            vertical-align: 5px;
            color: #166df1;
            text-align: center;
          "
        >
          私信获客宝
        </h3>
      </li>
      <li
        style="
          width: 37.5%;
          text-align: right;
          line-height: 40px;
          margin-bottom: 0;
          /* width: 100px; */
        "
      >
        <div class="user-box" :class="{ logged }" @click="showLogin">
          <span style="color: #777; font-weight: 600;">
            {{ truncateMixedString(userInfo.userName, 12) }}
          </span>
          <img
            @click="jumpUrl('https://huoke.5118.com/admin/welcome')"
            :src="
              userInfo.avatar || userInfo.userId
                ? require(`../assets/image/user/user1.png`)
                : require(`../assets/image/user/user.png`)
            "
            class="head-img"
            :onerror="`this.src='${require(`../assets/image/user/user.png`)}'`"
          />
          <ul>
            <li>
              <a href="https://huoke.5118.com/admin/welcome" target="_blank"
                >个人中心</a
              >
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div style="margin: 0 10px;">
      <h4 style="color: #aaaaaa; margin: 11px 0;">
        功能开关
      </h4>

      <div id="NewID" style="margin-top: 15px;">
        <ul style="width: 100%;">
          <li style="width: 70%;">
            <img
              src="../assets/image/F_switch.png"
              style="vertical-align: middle; margin-right: 8px; width: 30px;"
            />开启私信监控
          </li>
          <li style="width: 30%; text-align: right;">
            <div>
              <v-switch v-model="allpmswitch" style="z-index: 10;"></v-switch>
            </div>
          </li>
        </ul>
        <ul style="width: 100%;" class="ul_up_kefu">
          <li
            style="width: 90%; display: flex;"
            v-if="!is_check_domain && is_state_ok"
          >
            <div style="width: 36px;">
              <img
                src="../assets/image/no_monitoring.png"
                style="
                  width: 21px;
                  vertical-align: middle;
                  margin-right: 13px;
                  margin-left: 3px;
                "
              />
            </div>
            <div class="link_kf">
              暂不支持当前网站监控，
              <a href="javascript:void(0);" style="text-decoration: underline;"
                >请联系客服</a
              >
              <div class="link_qr_code"></div>
            </div>
          </li>
          <li
            style="width: 90%;"
            v-for="(item, index) of paginatedData"
            :key="index"
          >
            <div
              style="width: 100%; display: flex;"
              v-if="get_domain_user_count(plugin_p_list, item.type).length > 0"
            >
              <div style="width: 36px;">
                <img
                  :src="require(`../assets/image/pm/${item.img}`)"
                  style="
                    width: 21px;
                    vertical-align: middle;
                    margin-right: 13px;
                    margin-left: 3px;
                  "
                />
              </div>
              <div
                style="
                  width: 40px;
                  display: flex;
                  justify-content: space-between;
                  cursor: pointer;
                  border-bottom: 1px solid;
                  height: 20px;
                "
                @click="jumpUrl(item.jumpUrl)"
                v-html="
                  item.type
                    .split('')
                    .map((el) => `<span>${el}</span>`)
                    .join('')
                "
              ></div>
              <div>
                ：已启用{{
                  get_domain_user_count(plugin_p_list, item.type).length
                }}个账号
                <a
                  href="https://huoke.5118.com/admin/platform/account"
                  target="_blank"
                  style="text-decoration: underline;"
                  >查看账号</a
                >
              </div>
            </div>
            <div v-else-if="is_state_ok" style="width: 100%; display: flex;">
              <div style="width: 36px;">
                <img
                  :src="require(`../assets/image/pm/${item.img}`)"
                  style="
                    width: 21px;
                    vertical-align: middle;
                    margin-right: 13px;
                    margin-left: 3px;
                  "
                />
              </div>
              <div
                style="
                  width: 40px;
                  display: flex;
                  justify-content: space-between;
                "
                v-html="
                  item.type
                    .split('')
                    .map((el) => `<span>${el}</span>`)
                    .join('')
                "
              ></div>
              <div>
                ：无启用账号
                <a
                  :href="item.jumpUrl"
                  target="_blank"
                  style="text-decoration: underline;"
                  >去启用</a
                >
              </div>
            </div>
          </li>
          <!-- <li style="display: flex; margin-top: 5px;">
            <div>
              <button
                @click="prevPage"
                title="上一页"
                :disabled="currentPage === 1"
                style="
                  font-size: 12px;
                  cursor: pointer;
                  padding: 0px 5px;
                  border-radius: 4px;
                "
              >
                上一页
              </button>
              <button
                style="
                  font-size: 12px;
                  cursor: pointer;
                  margin-left: 30px;
                  padding: 0px 5px;
                  border-radius: 4px;
                "
                title="下一页"
                @click="nextPage"
                :disabled="currentPage === totalPages"
              >
                下一页
              </button>
            </div>
          </li> -->
        </ul>
      </div>

      <h4 style="color: #aaaaaa; margin: 10px 0;">
        快捷入口
      </h4>
      <div id="NewID" style="margin-top: 13px;">
        <ul style="width: 100%;">
          <li style="width: 30%;">
            <a href="https://huoke.5118.com/admin/welcome" target="_blank"
              >私信管理</a
            >
          </li>
          <li style="width: 30%;">
            <a
              href="https://huoke.5118.com/admin/platform/account/keyword"
              target="_blank"
              >自动回复</a
            >
          </li>
          <li style="width: 30%;">
            <a href="https://huoke.5118.com/admin/folder" target="_blank"
              >文件管理</a
            >
          </li>
        </ul>
        <ul style="width: 100%;">
          <li style="width: 30%;">
            <a
              href="https://huoke.5118.com/admin/platform/account/analyze"
              target="_blank"
              >分析统计</a
            >
          </li>
          <li style="width: 30%;">
            <a
              href="https://5118data.feishu.cn/docx/Q93HdoFprokrP4xSefIcfX6PnSh#share-D0OHdRC9PoQ09gxEauMcHyson1e"
              target="_blank"
              >常见问题</a
            >
          </li>
          <li style="width: 30%;">
            <a
              href="https://5118data.feishu.cn/docx/Q93HdoFprokrP4xSefIcfX6PnSh"
              target="_blank"
              >帮助文档</a
            >
          </li>
        </ul>
      </div>
      <div style="display: flex; align-items: center;">
        <h4 style="color: #aaaaaa; margin: 10px 0;">
          插件通知
        </h4>
        <h6 style="margin-left: 10px;">
          <a
            href="https://5118data.feishu.cn/docx/Q93HdoFprokrP4xSefIcfX6PnSh#share-DMivd7oVhoOPffxQfwAcDnHinmc"
            target="_blank"
            >账号离线怎么办？</a
          >
        </h6>

        <h6 style="margin-left: 10x;">
          <a
            href="https://5118data.feishu.cn/docx/Q93HdoFprokrP4xSefIcfX6PnSh#share-KIard0MRfoqSFrxdUSKcgT1gnYd"
            target="_blank"
            >自动回复测试不成功？</a
          >
        </h6>
      </div>

      <!-- <h5 style="color: #aaaaaa; margin: 5px;">账号</h5>
      <div id="PmMessage" style="margin-top: 15px;">
        <ul style="width: 100%;">
          <li class="messageinfo">5118私信插件发布上线</li>
          <li class="messageinfo">
            5118私信插件更新至V1.0.01版本
          </li>
          <li class="messageinfo">
            私信监控已支持B站，知乎，抖音，视频号
          </li>
          <li class="moremsg" style="width: 90%;">
            查看更多
          </li>
        </ul>
      </div> -->
      <!-- <h5 style="color: #aaaaaa; margin: 5px;">系统</h5> -->

      <!-- addTime id title-->

      <div
        id="PmMessage"
        style="margin-top: 10px; display: flex; justify-content: center;"
      >
        <ul v-if="plugin_p_message.length > 0">
          <li
            :title="
              item.title.indexOf('已被最小化') == -1
                ? '下线时间：' + item.addTime
                : '最小化时间：' + item.addTime
            "
            v-for="(item, index) of plugin_p_message"
            :key="index"
            class="messageinfo"
            :class="{ messagenew: timesDiff(item.addTime) < 24 }"
          >
            {{ item.title }}
          </li>
          <!-- <li class="moremsg" style="width: 90%;">
            查看更多
          </li> -->
        </ul>
        <ul v-else-if="is_message_ok" style="width: unset;">
          <li>
            <img
              src="../assets/image/no_message_info.png"
              style="
                vertical-align: middle;
                margin-right: 13px;
                margin-left: 3px;
                width: 55px;
              "
            />
            <br />
            <p style="margin: 6px; color: #666; font-size: 14px;">暂无通知</p>
          </li>
        </ul>
      </div>
      <div
        style="
          width: 100%;
          height: 1px;
          border-bottom: 1px dashed #ccc;
          box-sizing: border-box;
        "
      ></div>
      <ul
        style="width: 100%; display: flex; justify-content: flex-end;"
        class="linkul"
      >
        <!-- <li class="linkli" v-if="version <= 105">
          <a href="https://huoke.5118.com/?f=pmplugin" target="_blank"
            >功能介绍</a
          >
        </li> -->
        <!-- <li class="linkli" v-if="version < 105">
          <a
            href="https://www.5118.com/toutiao/huoke?f=pmplugin"
            target="_blank"
            >更新日志</a
          >
        </li> -->

        <!--
         -->
        <li class="linkli link_kf">
          <a href="javascript:void(0);" style="text-decoration: underline;"
            >联系客服</a
          >
          <div class="link_qr_code"></div>
        </li>
        <li class="link_lastV">V{{ version_str }}</li>
      </ul>
    </div>
    <Loading3 v-if="!logged" :version="version"></Loading3>
    <Upbox
      v-on:listenToCloseBox="listenToCloseBox"
      :isforce="is_force"
      :version="config_data.data.version"
      v-if="is_update"
    ></Upbox>
    <GuideLogo
      v-on:guideLogoToCloseBox="guideLogoToCloseBox"
      v-if="is_first_run_plugin && logged"
    ></GuideLogo>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import Loading3 from '../components/global/LoginBox3/Main';
import Upbox from '../components/global/Up/pm_main';
import GuideLogo from '../components/global/Up/guideLogo.vue';
import axios from 'axios';
export default {
  name: 'PopUpPM',
  watch: {
    allpmswitch(newVal) {
      this.$messengerpm.addTarget(window.parent, 'parent');
      this.$messengerpm.targets['parent'].send(
        'Plugin-5118-PM-All-Switch',
        newVal ? 1 : 2
      );
    },
  },
  data() {
    return {
      loginBox: null,
      isusersession: '',
      isuseruserinfo: '',
      is_check_domain: false,
      is_state_ok: false,
      is_message_ok: false,
      url: '',
      ptype: '',
      pnum: 0,
      data_domain_list: {
        data: [
          {
            type: '抖音',
            url: 'https://creator.douyin.com/',
            jumpUrl:
              'https://creator.douyin.com/creator-micro/data/following/chat',
            img: 'douyin.png',
            isshow: 1,
          },
          {
            type: '视频号',
            url: 'https://channels.weixin.qq.com',
            jumpUrl: 'https://channels.weixin.qq.com/platform/private_msg',
            img: 'shipinhao.png',
            isshow: 1,
          },
          {
            type: 'B站',
            url: 'bilibili.com',
            jumpUrl: 'https://message.bilibili.com/',
            img: 'bilibili.png',
            isshow: 1,
          },
          {
            type: '公众号',
            url: 'https://mp.weixin.qq.com',
            jumpUrl: 'https://mp.weixin.qq.com/',
            img: 'gongzhonghao.png',
            isshow: 1,
          },
          {
            type: '头条号',
            url: 'https://mp.toutiao.com',
            jumpUrl: 'https://mp.toutiao.com/profile_v4/personal/message',
            img: 'toutiao.png',
            isshow: 1,
          },
          {
            type: '知乎',
            url: 'https://www.zhihu.com',
            jumpUrl: 'https://www.zhihu.com/messages',
            img: 'zhihu.png',
            isshow: 1,
          },
          {
            type: '微信客服',
            url: 'https://kf.weixin.qq.com',
            jumpUrl:
              'https://huoke.5118.com/admin/platform/account?addtype=%E5%BE%AE%E4%BF%A1%E5%AE%A2%E6%9C%8D',
            img: 'wxkf.png',
            isshow: 0,
          },
          {
            type: '抖音',
            url: 'https://wwww.douyin.com',
            jumpUrl: 'https://wwww.douyin.com',
            img: 'douyin.png',
            isshow: 0,
          },
        ],
      },
      currentPage: 1,
      itemsPerPage: 100,
      plugin_p_list: [],
      plugin_p_message: [],
      version_str: '',
      h_time: null,
      config_data: {},
      is_update: false,
      is_force: false,
      is_first_run_plugin: false,
    };
  },
  components: {
    Loading3,
    Upbox,
    GuideLogo,
  },
  computed: {
    computedImageUrl(img_url) {
      // 根据 imageId 计算出图片地址
      return `../assets/image/pm/${img_url}`;
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.data_domain_list.data
        .filter((dataitem) => {
          return dataitem.isshow == 1;
        })
        .slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.data_domain_list.data.length / this.itemsPerPage);
    },
    allpmswitch: {
      get() {
        return this.$store.state.popup.allpmswitch;
      },
      set(val) {
        this.$store.state.popup.allpmswitch = val;
      },
    },
    version: {
      get() {
        return this.$store.state.popup.version;
      },
      set(val) {
        this.$store.state.popup.version = val;
      },
    },
    logged: {
      get() {
        return this.$store.state.user.logged;
      },
      set(val) {
        this.$store.state.user.logged = val;
      },
    },
    userInfo: {
      get() {
        return this.$store.state.user.userInfo;
      },
      set(val) {
        this.$store.state.user.userInfo = val;
      },
    },
  },
  mounted() {
    this.get_user_data();
    this.listenPopupinfo();
    this.get_userinfo_coookies();
    this.get_configData();
  },
  methods: {
    listenPopupinfo() {
      this.$messengerpm.listen('_5118_Pm_Isok', (msg) => {
        this.sendStatelist();
      });
      this.$messengerpm.listen(
        '_5118_Pm_Plugin_activate_domain',
        (domainData) => {
          this.url = domainData.url;
          this.getPmConfigData();
        }
      );

      // this.$messengerpm.listen('_5118_Pm_Plugin_popup_user_state', (msg) => {
      //   // for (let item of this.data_domain_list.data) {
      //   //   if (this.url.indexOf(item.url) != -1) {
      //   //     // this.plugin_p_list = msg.dataSource.filter((dataitem) => {
      //   //     //   return (
      //   //     //     dataitem.trustType === 'plugin' &&
      //   //     //     dataitem.robotType === item.type &&
      //   //     //     dataitem.state == 1
      //   //     //   );
      //   //     // });
      //   //   }
      //   //   this.plugin_p_list = msg.dataSource;
      //   // }

      //   this.plugin_p_list = msg.dataSource;
      //   console.log(this.plugin_p_list);
      //   this.is_state_ok = true;
      // });

      // this.$messengerpm.listen('_5118_Pm_Plugin_popup_message_info', (msg) => {
      //   this.plugin_p_message = msg.dataSource;
      //   this.is_message_ok = true;
      // });

      this.$messengerpm.listen('_5118_Pm_Plugin_Open_Close', (msg) => {
        if (msg === 1) {
          this.allpmswitch = true;
        } else {
          this.allpmswitch = false;
        }
      });
      this.$messengerpm.listen('_5118_PopUp_FirstRun_Plugin', (msg) => {
        if (msg === 'ok') {
          this.is_first_run_plugin = true;
        }
      });
      this.$messengerpm.listen('_5118_PopUp_Version_No', (msg) => {
        this.version = msg.replace(/\./gi, '');
        this.is_force = this.config_data.data.isforce;
        this.version_str = msg;
        if (this.version < 105) {
          document.getElementById('main_popup').style.width = '300px';
          this.send_popup_width();
        }
        if (this.config_data.data.version > this.version) {
          if (!this.is_force) {
            let last_show_time = localStorage.getItem('pm_update_time');
            if (last_show_time) {
              if (
                Math.floor(Date.now() / 1000) - Number(last_show_time) >
                3600 * 24
              ) {
                this.is_update = true;
              }
            } else {
              this.is_update = true;
            }
          } else {
            this.is_update = true;
          }
        }
      });
      this.$messengerpm.listen('_5118_Show_Main_Login', (msg) => {
        if (this.logged) {
          return;
        }
        if (this.loginBox) {
          this.loginBox.close();
          this.loginBox = null;
        }
        this.loginBox = this.$loginBox3();
      });
    },
    get_domain_user_count(list, name) {
      let plugin_count_list = list.filter((dataitem) => {
        return (
          (dataitem.trustType === 'plugin' || dataitem.trustType === 'api') &&
          dataitem.robotType === name &&
          dataitem.state == 1
        );
      });
      return plugin_count_list;
    },
    listenToCloseBox() {
      this.is_update = false;
      localStorage.setItem('pm_update_time', Math.floor(Date.now() / 1000));
    },
    guideLogoToCloseBox() {
      this.is_first_run_plugin = false;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.show_popup_height();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.show_popup_height();
      }
    },
    jumpUrl(url) {
      window.open(url);
    },
    send_popup_width() {
      let body_w = document.body.scrollWidth;
      // console.log(body_w);
      this.$messengerpm.targets['parent'].send(
        'Plugin-5118-Pm-Popup-Iframe_Width',
        body_w
      );
    },
    show_popup_height() {
      this.send_popup_width();
      this.h_time = setInterval(() => {
        if (this.is_state_ok && this.is_message_ok) {
          let body_h = document.body.scrollHeight;
          this.$messengerpm.targets['parent'].send(
            'Plugin-5118-Pm-Popup-Iframe_Height',
            body_h
          );
          clearInterval(this.h_time);
        }
      }, 1000);
    },
    sendStatelist() {
      this.$messengerpm.addTarget(window.parent, 'parent');
      this.$messengerpm.targets['parent'].send(
        'Plugin-5118-Pm-Popup-State',
        this.userInfo
      );
      this.show_popup_height();
    },
    truncateMixedString(str, maxLength) {
      let totalLength = 0;
      let result = '';
      if (str) {
        for (let char of str) {
          // 判断字符是否为汉字（基于 Unicode 范围）
          if (/[\u4e00-\u9fa5]/.test(char)) {
            totalLength += 2; // 汉字计为 2
          } else {
            totalLength += 1; // 英文字符计为 1
          }

          // 判断是否超过限制
          if (totalLength > maxLength) {
            result += '..'; // 超出限制后加点
            break;
          }

          result += char;
        }
      }
      return result;
    },
    timesDiff(time) {
      const targetDate = new Date(time);
      const currentDate = new Date();

      const timeDifference = currentDate - targetDate; // 时间差，单位为毫秒
      const hoursDifference = timeDifference / (1000 * 60 * 60); // 转换为小时
      return hoursDifference;
    },
    get_userinfo_coookies() {
      let userInfo = JSON.parse(Cookies.get('_5118_PM_UserInfo') || '{}') || {};
      this.logged = !!userInfo.userId;
      this.userInfo = userInfo;
      if (this.isusersession != 'nosession')
        this.isuseruserinfo = userInfo.userId || 'nosession';
    },
    async getPmConfigData() {
      // this.data_domain_list = await axios.get(
      //   'https://aiplugin.5118.com/domain_list.json?t=' +
      //     Math.floor(Date.now() / 1000 / 60)
      // );

      for (let item of this.data_domain_list.data) {
        if (this.url.indexOf(item.url) != -1) {
          this.is_check_domain = true;
        }
      }
    },
    async get_configData() {
      this.config_data = await axios.get(
        //https://p-aiplugin.5118.com
        'https://aiplugin.5118.com/config/tab_change_domain_list_new.json?t=' +
          Math.floor(Date.now() / 1000 / 60)
      );

      try {
        if (!this.userInfo.userId) {
          console.log('用户没有登录');
          return;
        }
        //http://p-huoke.5118.com
        let setting_data = await axios.get(
          'https://huoke.5118.com/api/accountsetting/list?UGUID=' +
            this.userInfo.userId +
            '&PageIndex=1&PageSize=1000',
          {
            headers: {
              Token: '937622D8-2844-4CCB-A3BD-E125244224AE',
            },
          }
        );
        if (setting_data.data.errorCode == 0) {
          this.plugin_p_list = setting_data.data.data.dataSource;
          this.is_state_ok = true;
        }
      } catch (error) {}

      try {
        if (!this.userInfo.userId) {
          console.log('用户没有登录');
          return;
        }
        let msg_data = await axios.get(
          'https://huoke.5118.com/api/accountsetting/Notice_GetListByPlugin?UGUID=' +
            this.userInfo.userId +
            '&Count=3',
          {
            headers: {
              Token: '937622D8-2844-4CCB-A3BD-E125244224AE',
            },
          }
        );
        if (msg_data.data.errorCode == 0) {
          this.plugin_p_message = msg_data.data.data.dataSource;
          this.is_message_ok = true;
        }
      } catch (error) {}
    },
    go_more_msg() {
      window.open('https://www.5118.com/toutiao/huoke?f=pmplugin');
    },
    showLogin() {
      if (!this.logged) {
        if (this.loginBox) {
          this.loginBox.close();
          this.loginBox = null;
        }
        this.loginBox = this.$loginBox3();
      }
    },
    get_user_data() {
      this.isusersession = Cookies.get('_5118_PM_UserInfo') || 'nosession';
    },
  },
};
</script>

<style type="text/less" lang="less" scoped>
@import '../assets/style/color';
@import '../assets/style/config';
@import '../assets/style/mixin';

.mian_width {
  width: 320px;
}
.mian_width_old {
  width: 300px;
}

.ul_up_kefu {
  .link_kf {
    position: relative;
    &:hover .link_qr_code {
      display: block;
    }
  }
  .link_qr_code {
    display: none; /* 默认隐藏二维码 */
    position: absolute;
    // bottom: 100%; /* 将二维码显示在元素的上方 */
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    height: 150px;
    background-image: url('https://s0.5118img.com/assist/images/Loosecode.png'); /* 替换为二维码图片路径 */
    background-size: cover;
    border: 1px solid #ccc;
    padding: 5px;
    background-color: #fff;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
  }
}

.linkul {
  .linkli {
    line-height: 15px !important;
    width: 23.333%;
    text-align: left;
    margin-left: 13px;
  }
  .link_lastV {
    line-height: 15px !important;
    float: right;
    margin-right: 5px;
    color: #ccc;
  }
  .link_kf {
    position: relative;
    &:hover .link_qr_code {
      display: block;
    }
  }
  .link_qr_code {
    display: none; /* 默认隐藏二维码 */
    position: absolute;
    bottom: 100%; /* 将二维码显示在元素的上方 */
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    height: 150px;
    background-image: url('https://s0.5118img.com/assist/images/Loosecode.png'); /* 替换为二维码图片路径 */
    background-size: cover;
    border: 1px solid #ccc;
    padding: 5px;
    background-color: #fff;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
  }
}
.user-box {
  display: inline-block;
  margin-right: 7px;
  position: relative;
  .head-img {
    vertical-align: -5px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: pointer;
  }
  ul {
    z-index: 999;
    padding: 0;
    position: absolute;
    background-color: white;
    box-shadow: #eaeaea 0 1px 6px 0;
    left: -35px;
    width: 95px;
    display: none;
    top: 35px;
    li {
      list-style: none;
      display: block;
      width: 100%;
      a {
        display: block;
        color: #999;
        padding: 0 15px;
        line-height: 35px;
        font-size: 14px;
        &:hover {
          background-color: #ebf5ff;
        }
      }
    }
  }
  &.logged {
    &:hover {
      ul {
        display: block;
      }
    }
  }
}
.messageinfo {
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 5px;
  margin-bottom: 5px;
}
.messagenew::after {
  content: '';
  background: url(../assets/image/new_ico.png) no-repeat;
  width: 30px;
  height: 14px;
  background-size: contain;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.moremsg {
  margin-top: 5px;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
}
</style>

<style>
/* body {
      width: 320px;
      min-height: 100px;
      margin: 0;
  } */
a {
  /* color: #333; */
  text-decoration: none;
}
a:hover {
  color: #2d7dff;
}
ul {
  display: table;
  width: 100%;
  padding: 0;
  margin: 5px 0;
}

ul li {
  list-style: none;
  margin-bottom: 4px;
  float: left; /* 往左浮动 */
  text-align: left;
  line-height: 21px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
}

li {
  list-style: none;
  margin-bottom: 4px;
  float: left; /* 往左浮动 */
  text-align: center;
  line-height: 30px;
  font-family: 'Lato', sans-serif;
  font-size: 10px;
}

.switch-input {
  display: none;
}

.switch-input:checked + .switch {
  background-color: #d5e5ff;
}

.switch-input:checked + .switch span {
  right: 0;
  left: auto;
  background-color: #2d7dff;
}

.switch {
  cursor: pointer;
  display: inline-block;
  width: 25px;
  background-color: #ccc;
  height: 12px;
  vertical-align: -1px;
  border-radius: 15px;
  position: relative;
}

.switch span {
  display: inline-block;
  height: 14px;
  width: 14px;
  left: 0;
  position: absolute;
  background-color: #888;
  top: -1px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/pages/PopUpPM.vue